import user from "./user"
import product from "./product.js"
import need from "./need.js"
import author from "./author.js"
export default {
    user,
    product,
    need,
    author
}